export const TOKEN_CLAIMS = {
  COOKIES: 'https://auth.jumio.ai/cookies'
} as const;

export const QUERY_PARAMS = {
  COOKIES: 'cookies'
} as const;
